'use strict';

/* globals jQuery Stripe yithStripePayments yithStripePaymentsElement */

import PaymentElement from './PaymentElement';

/**
 * Class that init and manages all interactions with Stripe Element on Checkout
 */
export default class PaymentElementCards extends PaymentElement {
	isAddMethod = true;

	/* === INITIALIZATION METHOD === */

	/**
	 * Returns an object with a set of options to be used for Elements init/update
	 *
	 * @return {Promise<object|boolean>} Settings object, or false on failure.
	 */
	async getElementsDetails() {
		return {
			mode: 'setup',
			setupFutureUsage: 'on_session',
			currency: yithStripePaymentsElement.currency,
			appearance: yithStripePaymentsElement.appearance,
		};
	}
}
